module.exports = __webpack_public_path__ + "img/icon_福利@2x.db8d4b94.png";